/**
 * Parse a UTC date string from the server, ensuring it's treated as UTC
 * even when the .NET serializer omits the trailing 'Z' (EF Core / SQL Server
 * returns DateTime with Kind=Unspecified, so no zone indicator is appended).
 */
export function parseServerDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const normalized =
    value.endsWith('Z') || value.includes('+') ? value : value + 'Z';
  return new Date(normalized);
}

/** Format a server date as a local time string (today → "10:15 PM", older → "May 22 10:15 PM") */
export function formatChatTime(sentAt: string): string {
  const d = parseServerDate(sentAt);
  if (!d) return '';
  const now = new Date();
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  if (sameDay) {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }
  return (
    d.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  );
}

/** Format a server date as a short date string ("May 22, 2026") */
export function formatShortDate(value: string | null | undefined): string {
  const d = parseServerDate(value);
  if (!d) return '';
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Format a server date as a locale date string ("5/22/2026") */
export function formatLocaleDate(value: string | null | undefined): string {
  const d = parseServerDate(value);
  if (!d) return '';
  return d.toLocaleDateString();
}
